import type { Theme, Components } from '@mui/material/styles';

import { tabClasses } from '@mui/material/Tab';

// ----------------------------------------------------------------------

const MuiTabs: Components<Theme>['MuiTabs'] = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { textColor: 'inherit', variant: 'scrollable', allowScrollButtonsMobile: true },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    // Sem isto o `minHeight: 41` do `MuiTab` é inerte: `Tabs.js:111` fixa
    // `minHeight: 48` na raiz e o `Tab`, filho flex de `.MuiTabs-list`, estica até
    // lá — o indicador ficaria ~7px abaixo da borda do rótulo. É o mesmo 41px que o
    // `GradeTabs` precisa cravar no `sx` hoje (§8 T6 / §4.1).
    root: { minHeight: 41 },
    // O canvas encosta as abas: 4px de gap em qualquer viewport (§8 T6).
    list: ({ ownerState }) => ({
      ...(ownerState.variant !== 'fullWidth' && { gap: '4px' }),
    }),
    indicator: ({ theme }) => ({ backgroundColor: theme.vars.palette.primary.main }),
  },
};

// ----------------------------------------------------------------------

const MuiTab: Components<Theme>['MuiTab'] = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { disableRipple: true, iconPosition: 'start' },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    // `.tab` do canvas: 13px/600, altura 41px, caixa original (§8 T6).
    root: ({ theme }) => ({
      opacity: 1,
      minWidth: 0,
      minHeight: 41,
      padding: '10px 14px',
      textTransform: 'none',
      color: theme.vars.palette.text.secondary,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 600,
      lineHeight: theme.typography.body2.lineHeight,
      [`&.${tabClasses.selected}`]: {
        color: theme.vars.palette.primary.main,
        fontWeight: 700,
        ...theme.applyStyles('dark', {
          color: theme.vars.palette.primary.light,
        }),
      },
    }),
  },
};

// ----------------------------------------------------------------------

export const tabs = { MuiTabs, MuiTab };
